import api from "./axios";

function buildFormData(file, extra = {}) {
  const form = new FormData();
  form.append("file", file);
  Object.entries(extra).forEach(([key, value]) => {
    if (value !== undefined && value !== null) form.append(key, String(value));
  });
  return form;
}

export async function inspectCatalogSpreadsheet(file, headerRow = 1) {
  const response = await api.post(
    "/store-imports/catalog/inspect",
    buildFormData(file, { header_row: headerRow }),
  );
  return response.data;
}

export async function previewCatalogSpreadsheet(file, config) {
  const response = await api.post(
    "/store-imports/catalog/preview",
    buildFormData(file, { config_json: JSON.stringify(config) }),
  );
  return response.data;
}

export async function commitCatalogSpreadsheet(file, config) {
  const response = await api.post(
    "/store-imports/catalog/commit",
    buildFormData(file, { config_json: JSON.stringify(config) }),
  );
  return response.data;
}
